import CreateProjectContainer from "../containers/CreateProjectContainer";

const CreateProjectPage = () => {
  return (
    <CreateProjectContainer />
  );
};

export default CreateProjectPage;
